import { render, staticRenderFns } from "./departmentRole.vue?vue&type=template&id=564408f2&scoped=true&"
import script from "./departmentRole.vue?vue&type=script&lang=ts&"
export * from "./departmentRole.vue?vue&type=script&lang=ts&"
import style0 from "./departmentRole.vue?vue&type=style&index=0&id=564408f2&lang=less&scoped=true&"
import style1 from "./departmentRole.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564408f2",
  null
  
)

export default component.exports